import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function ProgrammeOutcome() {
    const pos = [
        { po: 'PO1', title: 'Disciplinary Knowledge', desc: 'Demonstrate comprehensive knowledge in the chosen discipline.' },
        { po: 'PO2', title: 'Critical Thinking', desc: 'Apply analytical skills to evaluate problems and formulate solutions.' },
        { po: 'PO3', title: 'Communication Skills', desc: 'Communicate effectively in oral, written, and digital formats.' },
        { po: 'PO4', title: 'Research Aptitude', desc: 'Conduct basic research using appropriate methodologies.' },
        { po: 'PO5', title: 'Ethics & Values', desc: 'Exhibit ethical behavior and social responsibility in personal and professional life.' },
        { po: 'PO6', title: 'Lifelong Learning', desc: 'Demonstrate commitment to continuous learning and self-improvement.' },
    ];

    const psos = [
        { code: 'PSO1', title: 'Domain Competency', desc: 'Demonstrate subject-specific competencies and apply them in real-world contexts.' },
        { code: 'PSO2', title: 'Practical Skills', desc: 'Apply laboratory skills and hands-on techniques relevant to the specialization.' },
        { code: 'PSO3', title: 'Career Readiness', desc: 'Prepare for employment, higher education, and competitive examinations.' },
    ];

    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Academics › Programme Outcome &amp; Course Outcome</p>
                <h1>Programme Outcome &amp; Course Outcome</h1>
                <p>Defined learning outcomes aligned with NEP 2020 and SPPU guidelines.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>Programme Outcomes (PO)</h2>
                    <p style={{ marginBottom: '1rem', color: '#555' }}>
                        Programme Outcomes are broad statements defining graduate attributes expected of all students completing a degree programme at this institution.
                    </p>
                    <table className="data-table">
                        <thead><tr><th style={{ width: '10%' }}>Code</th><th style={{ width: '25%' }}>Outcome</th><th>Description</th></tr></thead>
                        <tbody>
                            {pos.map(p => (
                                <tr key={p.po}>
                                    <td style={{ fontWeight: 700, color: '#2d6a4f' }}>{p.po}</td>
                                    <td style={{ fontWeight: 600 }}>{p.title}</td>
                                    <td>{p.desc}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="info-card">
                    <h2>Programme-Specific Outcomes (PSO)</h2>
                    <p style={{ marginBottom: '1rem', color: '#555' }}>
                        PSOs define what students in a specific programme are expected to achieve upon graduation.
                    </p>
                    <table className="data-table">
                        <thead><tr><th style={{ width: '10%' }}>Code</th><th style={{ width: '25%' }}>Outcome</th><th>Description</th></tr></thead>
                        <tbody>
                            {psos.map(p => (
                                <tr key={p.code}>
                                    <td style={{ fontWeight: 700, color: '#1a3c5e' }}>{p.code}</td>
                                    <td style={{ fontWeight: 600 }}>{p.title}</td>
                                    <td>{p.desc}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="info-card">
                    <h2>Course Outcomes (CO)</h2>
                    <p>
                        Each individual course has defined Course Outcomes (COs) that specify what students will be able to do on completion of that course. COs are mapped to Programme Outcomes to ensure alignment. Detailed COs for each programme are available with the respective departments and on the Savitribai Phule Pune University website.
                    </p>
                    <div className="ext-links">
                        <a href="https://www.unipune.ac.in" target="_blank" rel="noreferrer" className="ext-link-chip">🔗 SPPU Website</a>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default ProgrammeOutcome;
